export default __webpack_public_path__ + "static/media/rnr-sports-table-24-cn.f01ea452.webp";